import { useEffect } from "react";

export const useTitle = (title) => {
  const appName = localStorage.getItem("AppName") || "PayLoft";
  useEffect(() => {
    document.title = `${title} / ${appName}`;
  }, [title, appName]);

  return null;
};
